import { Menu, MenuButton, MenuItem } from '@szhsin/react-menu';
import styled from 'styled-components';

export const StyledWorkflowCard = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: start;
  gap: 10px;
  position: relative;
  width: 100%;
  padding: 12px;
  border-radius: 12px;
  border: 1px solid rgba(157, 157, 157, 0.5);
  background: transparent;

  .card-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 5px;
    margin: 0 0 10px;
    padding: 0 23px 0 0;
    position: relative;

    .img-box {
      flex-shrink: 0;
      width: 30px;

      img {
        display: block;
        width: 100%;
        height: auto;
      }
    }
  }

  .text-box {
    flex-grow: 1;
    font-size: 16px;
    line-height: 20px;
    color: var(--light-gray);

    .title {
      display: block;
      font-size: 18px;
      line-height: 22px;
      font-weight: 600;
      margin: 0 0 10px;
      text-transform: capitalize;
      color: var(--text-color);
    }
  }

  .card-footer {
    display: flex;
    align-items: center;
    gap: 5px;
    font-size: 13px;
    line-height: 16px;
    font-weight: 600;

    .date {
      display: block;
      color: var(--light-gray);
    }
  }
`;

export const MenuBtn = styled(MenuButton)`
  position: absolute;
  top: 2px;
  right: 0;
  font-size: 20px;
  line-height: 1px;
`;
export const ReponseMenu = styled(Menu)`
  box-shadow:
    0 0 7px rgba(0, 0, 0, 0.133),
    0 0 2px rgba(0, 0, 0, 0.1);

  ul {
    width: 200px;
    padding: 10px;
    border-radius: 15px;

    .text {
      font-size: 14px;
      line-height: 17px;
    }
  }
  &.szh-menu-container {
    left: 0 !important;
    right: 0 !important;
  }
  .szh-menu {
    left: auto !important;
    right: 0 !important;
    z-index: 10 !important;
  }
`;

export const StyleItem = styled(MenuItem)`
  display: block;
  padding: 4px 8px;
  margin: 0 0 2px;
  border-radius: 3px;

  &.active,
  &:hover {
    background: var(--gray-100);
  }

  &:last-child {
    margin: 0;
  }
`;
